module.exports = "<div class=\"main-loader\" [hidden]=\"!loading\"></div>\r\n"